const isSingleTruthyValue = arr => Boolean(arr && Array.isArray(arr) && arr.length === 1 && arr[0]);
export default isSingleTruthyValue;